import React, { useState } from "react";
import "./CoursePopUp.css";

const CoursePopUp = ({ onClose, onSubmit, isLoading }) => {
  const [courseName, setCourseName] = useState("");
  const [courseDescription, setCourseDescription] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (currentStep === 2) {
      if (!courseName.trim()) {
        alert("Course name cannot be empty");
        return;
      }

      setIsSubmitting(true);
      onSubmit({
        courseName: courseName.trim(),
        courseDescription: courseDescription.trim(),
      });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && currentStep === 1) {
      e.preventDefault();
      goToNextStep();
    }
  };

  const goToNextStep = () => {
    if (currentStep === 1) {
      if (!courseName.trim()) {
        alert("Course name cannot be empty");
        return;
      }
      setCurrentStep(2);
    }
  };

  const goToPreviousStep = () => {
    if (currentStep === 2) {
      setCurrentStep(1);
    }
  };

  return (
    <div className="course-popup-modal">
      <div className="course-popup-content">
        {currentStep === 2 && (
          <button
            type="button"
            className="back-arrow-button"
            onClick={goToPreviousStep}
            disabled={isLoading || isSubmitting}
          >
            ←
          </button>
        )}
        <div className="modal-header">
          <h2 className="course-popup-title">Create a New Course</h2>
          <button
            className="close-button"
            onClick={onClose}
            disabled={isLoading || isSubmitting}
          >
            &times;
          </button>
        </div>

        <form className="course-popup-form" onSubmit={handleSubmit}>
          {/* Step indicator */}
          <div className="step-indicator">
            <div
              className={`step ${currentStep === 1 ? "active" : ""} ${
                courseName.trim() ? "completed" : ""
              }`}
            >
              1
            </div>
            <div className="step-line"></div>
            <div className={`step ${currentStep === 2 ? "active" : ""}`}>2</div>
          </div>

          {currentStep === 1 && (
            <div className="course-popup-form-group">
              <div className="course-popup-guide">
                <p className="guide-step">
                  Step 1: Give your new course a name
                </p>
              </div>
              <label>Course Name</label>
              <input
                type="text"
                value={courseName}
                onChange={(e) => setCourseName(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Enter the name of the new course..."
                className="course-popup-input"
                autoFocus
                disabled={isLoading || isSubmitting}
              />

              <div className="course-popup-nav-buttons">
                <button
                  type="button"
                  className="course-popup-next"
                  onClick={goToNextStep}
                  disabled={!courseName.trim() || isLoading || isSubmitting}
                >
                  Next
                </button>
              </div>
            </div>
          )}

          {currentStep === 2 && (
            <div className="course-popup-form-group">
              <div className="course-popup-guide">
                <p className="guide-step">
                  Step 2: Add a description for your course (optional)
                </p>
              </div>
              <label>Course Description</label>
              <textarea
                value={courseDescription}
                onChange={(e) => setCourseDescription(e.target.value)}
                placeholder="Enter a description for the course (optional)..."
                className="course-popup-textarea"
                rows={4}
                autoFocus
                disabled={isLoading || isSubmitting}
              />

              <button
                type="submit"
                className="course-popup-submit full-width-button"
                disabled={isLoading || isSubmitting || !courseName.trim()}
              >
                {isLoading || isSubmitting
                  ? "Creating Course..."
                  : "Create Course"}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default CoursePopUp;
